import '../../monitoring/filters/applied_text_view.js.coffee'

Namespace 'Profiling.Dashboard.Filters'

class Profiling.Dashboard.Filters.AppliedTextView extends Monitoring.Views.SocialContents.Filters.AppliedTextView
  _triggerQueryChanged: =>
    @searchQuery.triggerFilterChanged()
